import { render, staticRenderFns } from "./TituloRelatorioTurmasAluno.vue?vue&type=template&id=6d98f7be&"
import script from "./TituloRelatorioTurmasAluno.vue?vue&type=script&lang=js&"
export * from "./TituloRelatorioTurmasAluno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports